import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Input, Label } from "reactstrap";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { AppConfigDto } from "../../interfaces";
import { ActivityButton, BreadCrumb } from "../../components/Common";
import { toast } from "react-toastify";
import {
  useGetAppConfigsQuery,
  useUpdateAppConfigsMutation,
} from "../../store/api/appConfigApi";

type TProps = RouteComponentProps & {};
const EnableDisableComponent: React.FC<TProps> = () => {
  //#region hooks
  const { t } = useTranslation();
  //#endregion

  document.title = `${t("documentTitle", { pageName: "controlApp" })}`;

  //#region internal state
  const [configs, setConfigs] = useState<AppConfigDto[]>([]);
  //#endregion

  const {
    data: dataAppConfigs,
    isLoading: isLoadingAppConfigs,
    isSuccess: isSuccessAppConfigs,
    error: errorAppConfigs,
  } = useGetAppConfigsQuery();

  const [
    updateAppConfigs,
    {
      isLoading: isLoadingUpdateAppConfigs,
      isSuccess: isSuccessUpdateAppConfigs,
    },
  ] = useUpdateAppConfigsMutation();

  useEffect(() => {
    if (!isLoadingAppConfigs && isSuccessAppConfigs && dataAppConfigs) {
      setConfigs(dataAppConfigs);
    }
    if (!isLoadingAppConfigs && errorAppConfigs) {
    }
  }, [isLoadingAppConfigs, isSuccessAppConfigs, errorAppConfigs]);

  const onChangeValue = (key: string, checked: boolean) => {
    const changedValues = configs.map((c) =>
      c.key === key ? { ...c, value: String(checked) } : c,
    );

    setConfigs(changedValues);
  };

  const onSave = () => {
    updateAppConfigs({ configs: configs });
  };

  useEffect(() => {
    if (!isLoadingUpdateAppConfigs && isSuccessUpdateAppConfigs) {
      toast.success(t("savedSuccessfully"), {
        autoClose: 3000,
      });
    }
  }, [isLoadingUpdateAppConfigs, isSuccessUpdateAppConfigs]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("enableDisable")} pageTitle={t("controlApp")} />
          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <Row className="g-2">
                    {configs?.map((d) => {
                      return (
                        <Col lg={3}>
                          <div>
                            <div className="form-check mb-4 mt-2">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                id={d.key}
                                checked={/true/i.test(d.value)}
                                value={d.value}
                                onChange={({ target }) => {
                                  onChangeValue(d.key, target.checked);
                                }}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor={d.key}
                              >
                                {t(d.key)}
                              </Label>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                  <Row>
                    <Col lg={3}>
                      <ActivityButton
                        title="save"
                        inProgressTitle="saving"
                        color="success"
                        className="btn btn-success"
                        type="submit"
                        inProgress={isLoadingUpdateAppConfigs}
                        disabled={
                          isLoadingUpdateAppConfigs || isLoadingAppConfigs
                        }
                        onClick={onSave}
                      ></ActivityButton>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export const EnableDisablePage = withRouter(EnableDisableComponent);
